import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 7"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#fff",
      opacity: ".8"
    }, [
      _createElementVNode("path", { d: "M3.047 4.793c1.5-1.34 3.31-2.61 5.34-2.79.4-.04.75-.32.75-.75 0-.38-.34-.79-.75-.75-2.49.23-4.59 1.61-6.4 3.23-.3.27-.28.79 0 1.06.3.3.76.27 1.06 0M.728 6.613c.97 0 .97-1.5 0-1.5s-.97 1.5 0 1.5" })
    ], -1)
  ])))
}
export default { render: render }